module.exports = __webpack_public_path__ + "img/revotas-logo.d2e2911c.svg";